import InstagramObject from "./InstagramObject";

export default InstagramObject;
